import Axios from "../BaseAxios";
import {
  API_CLIENT_URL,
  API_COMMON_URL,
  ROUTER_URL,
} from "../../constants/urls";
import Keys from "../../constants/keys";
import store from "../../store";
import PaymentApiHelper from "./PaymentApis";
import router from "../../router";
import authToken from "../../common/authToken";
import AmplitudeHelper from "../../amplitude";

const SessionSeriesApiHelper = {
  getSessionSeries(
    dataTableParams,
    successHandler,
    failureHandler,
    isCancle = false
  ) {
    Axios.request_POST(
      API_CLIENT_URL.sessionSeriesList,
      dataTableParams,
      {},
      successHandler,
      failureHandler,
      isCancle
    );
  },
  getSessionSeriesDetails(
    params,
    fnSuccessResponse = null,
    fnFailureResponse = null
  ) {
    store.state.sessionSeriesDetails.loading = true;

    const successHandler = (res) => {
      store.state.sessionSeriesDetails.loading = false;

      store.state.sessionSeriesDetails.data = res.data.data;
      store.state.sessionSeriesDetails.nextEvents = res.data.next_events;
      if (fnSuccessResponse != null) {
        fnSuccessResponse(res);
      }
    };

    const failureHandler = (res) => {
      console.log(res);
      store.state.sessionSeriesDetails.loading = false;
      if (fnFailureResponse != null) {
        fnFailureResponse(res);
      }
    };

    Axios.request_GET(
      API_CLIENT_URL.groupSessionSeriesDetails,
      params,
      {},
      successHandler,
      failureHandler
    );
  },
  requestWebinar(fnSuccessResponse = null, fnFailureResponse = null) {
    let dataTableParams = {};

    Axios.request_POST(
      API_CLIENT_URL.requestSession,
      dataTableParams,
      {},
      fnSuccessResponse,
      fnFailureResponse
    );
  },
  enrollForSessionSeries(sessionSeries, isMembershipEnabled = true) {
    if (!sessionSeries.is_bought) {
      if (
        sessionSeries.is_free ||
        authToken.decodedToken().is_member ||
        !isMembershipEnabled
      ) {
        SessionSeriesApiHelper.enrollFreeSubscription(sessionSeries.id);
      } else {
        SessionSeriesApiHelper.makeOrderId();
      }
    } else {
      store.state.sessionSeriesDetails.purchased = sessionSeries;
      if (sessionSeries.status == "On-Demand") {
        router.push({
          name: ROUTER_URL.publicSession.children.sessionOnDemandDetails.name,
        });
        store.state.workshop.buttonLoading = false;
        store.state.webinar.buttonLoading = false;
      } else {
        store.dispatch("snackBar/showToast", {
          message:
            sessionSeries.status == "Scheduled"
              ? "You have already registered for this " +
                sessionSeries.type.toLowerCase()
              : "You have already requested for this " +
                sessionSeries.type.toLowerCase(),
          color: "S",
        });
        store.state.workshop.singleWorkshopBtnLoading = false;
        store.state.workshop.buttonLoading = false;
        store.state.webinar.buttonLoading = false;
      }
    }
  },
  makeOrderId() {
    let successHandler = (res) => {
      console.log(res);
      this.initiatePayment(res.data.transaction_id, res.data.id);
      store.state.workshop.buttonLoading = false;
      store.state.webinar.buttonLoading = false;
      store.state.workshop.singleWorkshopBtnLoading = false;
    };

    const failureHandler = (res) => {
      store.state.workshop.buttonLoading = false;
      store.state.webinar.buttonLoading = false;
      store.state.workshop.singleWorkshopBtnLoading = false;
      console.log(res);
    };

    var requestParams = {};
    requestParams[Keys.SESSION_SERIES_ID] = store.state.payment.sessionSeriesId;
    requestParams[Keys.SESSIONS] = store.state.payment.sessions;

    requestParams[Keys.SOURCE] = store.state.userUTM.utm_source;
    requestParams[Keys.MEDIUM] = store.state.userUTM.utm_medium;
    requestParams[Keys.CAMPAIGN] = store.state.userUTM.utm_campaign;

    PaymentApiHelper.getPaymentOrderId(
      requestParams,
      successHandler,
      failureHandler
    );
  },
  initiatePayment(transaction_id, order_id) {
    store.state.payment.transactionId = transaction_id;
    const paymentSuccessHandler = (res) => {
      console.log("razorPay Response:", res);

      this.verifyPayment(
        res.razorpay_payment_id,
        res.razorpay_order_id,
        res.razorpay_signature
      );
    };

    const paymentFailureHandler = (res) => {
      console.log(res);
    };

    PaymentApiHelper.initiatePayment(
      transaction_id,
      store.state.payment.amount,
      "Eblity Session",
      store.state.payment.discription,
      order_id,
      paymentSuccessHandler,
      paymentFailureHandler
    );
  },
  verifyPayment(razorpay_payment_id, razorpay_order_id, razorpay_signature) {
    store.state.workshop.buttonLoading = true;
    const paymentVerifySuccessHandler = (res) => {
      console.log(res);
      store.state.sessionSeriesDetails.purchased =
        store.state.sessionSeriesDetails.data;

      if (store.state.sessionSeriesDetails.data.type == "Group session") {
        const studentSessionLinkSuccessHandler = (res) => {
          console.log("razorPay Response:", res);
          router.push({
            name: ROUTER_URL.publicSession.children.sessionThankYou.name,
          });
        };
        const studentSessionLinkFailureHandler = (res) => {
          console.log(res);
        };
        PaymentApiHelper.assignSessionToStudentAfterpaymentSuccess(
          studentSessionLinkSuccessHandler,
          studentSessionLinkFailureHandler
        );
      } else {
        //Thank You Page or Watch Webinar (in case of on-demand)
        if (store.state.sessionSeriesDetails.data.status == "On-Demand") {
          router.push({
            name: ROUTER_URL.publicSession.children.sessionOnDemandDetails.name,
          });
        } else {
          router.push({
            name: ROUTER_URL.publicSession.children.sessionThankYou.name,
          });
        }
      }
    };

    const paymentVerifyFailureHandler = (res) => {
      console.log(res);
      store.state.workshop.buttonLoading = false;
    };

    PaymentApiHelper.verifyPayment(
      razorpay_payment_id,
      razorpay_order_id,
      razorpay_signature,
      store.state.payment.transactionId,
      paymentVerifySuccessHandler,
      paymentVerifyFailureHandler
    );
  },
  enrollFreeSubscription(session_series_id) {
    let params = {};
    params[Keys.SESSION_SERIES_ID] = session_series_id;

    params[Keys.SOURCE] = store.state.userUTM.utm_source;
    params[Keys.MEDIUM] = store.state.userUTM.utm_medium;
    params[Keys.CAMPAIGN] = store.state.userUTM.utm_campaign;

    params[Keys.SOURCE] = store.state.userUTM.utm_source;
    params[Keys.MEDIUM] = store.state.userUTM.utm_medium;
    params[Keys.CAMPAIGN] = store.state.userUTM.utm_campaign;

    params[Keys.SOURCE] = store.state.userUTM.utm_source;
    params[Keys.MEDIUM] = store.state.userUTM.utm_medium;
    params[Keys.CAMPAIGN] = store.state.userUTM.utm_campaign;

    store.state.workshop.buttonLoading = true;

    const successHandler = (res) => {
      console.log(res);

      if (store.state.sessionSeriesDetails.data.type == "Webinar") {
        AmplitudeHelper.registerAmplitudeEvent(
          "webinar registration success",
          SessionSeriesApiHelper.getEventProperties({
            "webinar name": store.state.sessionSeriesDetails.data.title,
          })
        );
      } else if (store.state.sessionSeriesDetails.data.type == "Workshop") {
        AmplitudeHelper.registerAmplitudeEvent(
          "workshop registration success",
          SessionSeriesApiHelper.getEventProperties({
            "workshop name": store.state.sessionSeriesDetails.data.title,
          })
        );

        if (
          !store.state.isMembershipEnabled &&
          !authToken.decodedToken().is_member
        )
          AmplitudeHelper.registerAmplitudeEvent("new membership success", {
            "workshop name": store.state.sessionSeriesDetails.data.title,
          });
      }

      if (res.data.token) {
        localStorage.setItem("token", res.data.token);

        authToken.deleteCookie(`accesstoken`);

        document.cookie = `accesstoken=${res.data.token}; domain=.eblity.com`;
      }

      store.state.sessionSeriesDetails.purchased =
        store.state.sessionSeriesDetails.data;
      //Thank You Page or Watch Webinar (in case of on-demand)
      if (store.state.sessionSeriesDetails.data.status == "On-Demand") {
        router.push({
          name: ROUTER_URL.publicSession.children.sessionOnDemandDetails.name,
        });
      } else {
        if (store.state.sessionSeriesDetails.data.type == "Webinar") {
          router.push({
            name: ROUTER_URL.publicSession.children.webinarThankYou.name,
          });
        } else if (store.state.sessionSeriesDetails.data.type == "Workshop") {
          router.push({
            name: ROUTER_URL.publicSession.children.workshopThankYou.name,
          });
        }
      }
      store.state.workshop.buttonLoading = false;
      store.state.webinar.buttonLoading = false;
      store.state.workshop.singleWorkshopBtnLoading = false;
    };

    const failureHandler = (res) => {
      console.log(res);
      store.state.workshop.buttonLoading = false;
      store.state.webinar.buttonLoading = false;
      store.state.workshop.singleWorkshopBtnLoading = false;
    };

    Axios.request_POST(
      API_COMMON_URL.freeSessionSeriesSubscription,
      params,
      {},
      successHandler,
      failureHandler,
      false,
      true
    );
  },
  getEventProperties(properties) {
    properties["tags"] = [
      ...new Set(
        store.state.sessionSeriesDetails.data.tags.map(
          (element) => element.name
        )
      ),
    ];
    properties["skills"] = [
      ...new Set(
        store.state.sessionSeriesDetails.data.skills.map(
          (element) => element.name
        )
      ),
    ];
    properties["age group"] = [
      ...new Set(
        store.state.sessionSeriesDetails.data.age_groups.map(
          (element) => element.name
        )
      ),
    ];
    return properties;
  },
};

export default SessionSeriesApiHelper;
